import { render, staticRenderFns } from "./mainbox.vue?vue&type=template&id=75c5c85b&scoped=true&"
import script from "./mainbox.vue?vue&type=script&lang=js&"
export * from "./mainbox.vue?vue&type=script&lang=js&"
import style0 from "./mainbox.vue?vue&type=style&index=0&id=75c5c85b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c5c85b",
  null
  
)

export default component.exports